import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { BenefitsLegacy, StageLegacy } from "@silvertours/front-features";
import { Body } from "./body";
var NewsletterContent = function(_param) /*#__PURE__*/ {
    var content = _param.content, commonProps = _object_without_properties(_param, [
        "content"
    ]);
    return _jsx(Body, _object_spread({
        stage: /*#__PURE__*/ _jsx(StageLegacy.NewsletterStage, {}),
        content: function(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ _jsx(BenefitsLegacy.Usp, {
                    translationKey: "newsletterUsps"
                })), 
            ];
        }
    }, commonProps));
};
export { NewsletterContent };
